@import "../../sass/variables/colors";

/**
@prop --ux-switch-control-width: Width of the switch button
@prop --ux-switch-control-height: Height of the switch button
@prop --ux-switch-outline-offset: Outline offset of the handle
@prop --ux-switch-outline-width: Outline width of the handle
@prop --ux-switch-handle-bg-color: Color of the handle
@prop --ux-switch-handle-size: Size of the handle
@prop --ux-switch-handle-offset: Inner offset of the handle
@prop --ux-switch-handle-track-length: Length of the handle track
@prop --ux-switch-handle-bg-color: Color of the handle
@prop --ux-switch-handle-border-color: Border color of the handle
@prop --ux-switch-handle-shadow: Shadow of the handle
@prop --ux-switch-desc-font-size: Font size of the description text
@prop --ux-switch-bg-color: Background color of the switch button
@prop --ux-switch-border-color: Border color of the switch button
@prop --ux-switch-on-bg-color: Background color of the switch button if toggled on
@prop --ux-switch-on-border-color: Border color of the switch button if toggled on
@prop --ux-switch-hover-bg-color: Background color of the switch button if hovered
@prop --ux-switch-hover-border-color: Border color of the switch button if hovered
@prop --ux-switch-focus-bg-color: Background color of the switch button if focused
@prop --ux-switch-focus-border-color: Border color of the switch button if focused
@prop --ux-switch-active-bg-color: Background color of the switch button if focused
@prop --ux-switch-active-border-color: Border color of the switch button if active
@prop --ux-switch-active-handle-bg-color: Color of the handle if active
@prop --ux-switch-disabled-bg-color: Background color of the switch button if disabled
@prop --ux-switch-disabled-border-color: Border color of the switch button if disabled
 */
.ux-switch-input {
  display: block;

  &__inner {
    align-items: center;
    display: flex;
    flex-flow: row nowrap;
    justify-content: stretch;
  }

  .ux-label {
    flex: 1 1 auto;
    font-family: var(--ux-font);
    font-size: var(--ux-input-label-font-size, var(--ux-label-font-size));
    font-weight: var(--ux-input-label-font-weight, var(--ux-label-font-weight));
    line-height: var(--ux-input-label-line-height, var(--ux-label-line-height));
    margin: 0;
    padding: 0 1em 0 0;
    text-transform: var(--ux-input-label-text-tranform, var(--ux-label-text-tranform));
  }

  &__handle {
    background-color: var(--ux-switch-handle-bg-color);
    border: var(--ux-switch-border-width) solid var(--ux-switch-handle-border-color);
    border-radius: var(--ux-switch-handle-size);
    box-shadow: var(--ux-switch-handle-shadow);
    box-sizing: border-box;
    display: block;
    height: var(--ux-switch-handle-size);
    left: var(--ux-switch-handle-offset);
    outline: var(--ux-switch-outline-width) solid transparent;
    outline-offset: var(--ux-switch-outline-offset);
    position: absolute;
    top: var(--ux-switch-handle-offset);
    transition: transform $animationSpeed-fast ease;
    width: var(--ux-switch-handle-size);
  }

  &__button {
    background-color: var(--ux-switch-bg-color, transparent);
    border: var(--ux-switch-border-width) solid var(--ux-switch-border-color);
    border-radius: var(--ux-switch-control-height);
    cursor: pointer;
    display: inline-block;
    flex: 0 0 auto;
    height: var(--ux-switch-control-height);
    margin: 0;
    outline: var(--ux-switch-outline-width) solid transparent;
    outline-offset: var(--ux-switch-outline-offset);
    padding: 0;
    position: relative;
    transition: background-color $animationSpeed-fast ease;
    user-select: none;
    width: var(--ux-switch-control-width);

    &:disabled {
      background-color: var(--ux-switch-disabled-bg-color);
      border-color: var(--ux-switch-disabled-border-color);
    }
  }

  &__button:focus-visible {
    background-color: var(--ux-switch-focus-bg-color);

    .ux-switch-input__handle {
      outline-color: var(--ux-switch-focus-border-color);
      outline-offset: var(--ux-switch-outline-offset);
    }
  }

  &__button:hover {
    background-color: var(--ux-switch-hover-bg-color);
    border-color: var(--ux-switch-hover-border-color);

    .ux-switch-input__handle {
      border-color: var(--ux-switch-hover-border-color);
    }
  }

  &__button:not(:disabled):active {
    background-color: var(--ux-switch-active-bg-color);
    border-color: var(--ux-switch-active-border-color);

    .ux-switch-input__handle {
      background-color: var(--ux-switch-active-handle-bg-color);
      border-color: var(--ux-switch-active-border-color);
    }
  }

  &__button:disabled {
    background-color: var(--ux-switch-disabled-bg-color);
    border-color: var(--ux-switch-disabled-border-color);
  }

  &__desc {
    font-size: var(--ux-switch-desc-font-size);
    margin-top: 10px;
  }

  &--label-placement-end {
    .ux-switch-input__inner {
      flex-direction: row-reverse;
    }

    .ux-label {
      padding: 0 0 0 1em;
    }
  }

  &.ux-switch-input--on {
    .ux-switch-input__button {
      background-color: var(--ux-switch-on-bg-color);
      border-color: var(--ux-switch-on-border-color);
    }

    .ux-switch-input__handle {
      transform: translateX(var(--ux-switch-handle-track-length));
    }
  }

  &.ux-switch-input--disabled {
    .ux-switch-input__button {
      background-color: var(--ux-switch-disabled-bg-color);
      border-color: var(--ux-switch-disabled-border-color);
      cursor: not-allowed;
    }

    .ux-switch-input__handle {
      background-color: var(--ux-switch-handle-bg-color);
      border-color: var(--ux-switch-disabled-border-color);
      box-shadow: none;
    }
  }
}
